import { loadMarketKlines } from './market_proxy_client';
import binance from './binance_service';
import fyers from './fyers_service';
import upstox from './upstox_service';
import dhan from './dhan_service';
import alice from './aliceblue_service';
import indian from './indian_market_service';

export function supportsHistory(connector) {
    return ['Binance', 'Fyers', 'Upstox', 'Dhan', 'Indian', 'AliceBlue', 'Coinbase', 'Kraken', 'Bybit', 'OKX', 'AMFI'].includes(connector);
}
export async function fetchEarlierHistory({ connector, symbol, pairId, exchange, timeframe }, cursor) {
    if (['Coinbase', 'Kraken', 'Bybit', 'OKX', 'AMFI'].includes(connector)) return loadMarketKlines(connector.toLowerCase(), symbol, timeframe, cursor - 1);
    if (connector === 'Binance') {
        const response = await binance.loadKlineFromBinance(symbol.split(':').pop(), timeframe, cursor - 1);
        const rows = await response.json();
        if (!response.ok || !Array.isArray(rows)) throw new Error(rows.msg || 'Unable to load earlier candles.');
        return rows.map(row => row.slice(0, 6).map(Number));
    }
    if (connector === 'Fyers') return fyers.loadHistoricalData(symbol.includes(':') ? symbol : `${exchange}:${symbol}`, timeframe, 0, cursor - 1);
    if (connector === 'Upstox') return upstox.loadHistoricalData(pairId || symbol, timeframe, 0, cursor - 1);
    if (connector === 'Dhan') return dhan.loadHistoricalData(pairId || symbol, timeframe, 0, cursor - 1);
    if (connector === 'Indian' || connector === 'AliceBlue') {
        if (String(pairId || '').includes('|')) return indian.loadHistoricalData(pairId, timeframe, cursor - 1);
        return alice.loadHistoricalData(`${exchange}:${pairId || symbol}`, timeframe, 0, cursor - 1);
    }
    throw new Error('Earlier history is unavailable for this data provider.');
}
